<template lang="pug">
div
  el-row
    el-col(:ms="12")
      h2
        span Администратори
        el-button(type="success", icon="el-icon-plus", @click="$router.push(url + '/new')") Добави

  el-form(:model="filters")
    el-row
      el-col(:sm="4")
        el-form-item
          el-input(v-model="filters.name" placeholder="Име")
      el-col(:sm="2")
        el-form-item
          el-button(@click="clearFilters") Изчисти

  datatable(ref="datatable", :url="apiUrl", :filters="filters")
    el-table-column(prop="name", label="Име", sortable="custom")
      template(slot-scope="scope")
        router-link(:to="url + '/' + scope.row.id") {{ scope.row.name }}
    el-table-column(prop="username", label="Потребителско име", width="420", sortable="custom")
    el-table-column(prop="isSuper", label="Главен администратор", width="280", sortable="custom", :formatter="booleanFormatter", align="center")

</template>

<script>
import Datatable from './Datatable.vue'
import listMixin from '../mixins/listMixin.js'

export default {
  name: 'UserList',
  mixins: [listMixin],
  data () {
    return {
      url: '/users',
      apiUrl: '/users',
      filters: {
        name: '',
      }
    }
  },
  methods: {

  },
  components: {
    Datatable
  }
}
</script>